export function TalentPoolFilledSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/talent-pool-filled.svg'"></ng-include>`
    }
}